export function RenderIf({isTrue = true, children}) {
  return isTrue ? children : null;
}